import React from "react";
import { CardTitle } from "material-ui/Card";
import RaisedButton from "material-ui/RaisedButton";
import { Link } from "react-router";
import OptionSorter from "./OptionSorter";
import CaveatVisualizationRow from "../components/CaveatVisualizationRow";
import { CUSTOMIZED_ORDER } from "../actions/filterOptions";
import OptionTitle from "../components/resultItems/OptionTitle";
import CondensedCaveatAvatars from "../components/resultItems/CondensedCaveatAvatars";
import PassFailCriteria from "../components/resultItems/PassFailCriteria";
import OptionInlineCategory from "../components/resultItems/OptionInlineCategory";
import Notes from "../components/resultItems/Notes";
import ToggleHideOption from "../components/resultItems/ToggleHideOption";
import Star from "./resultItems/Star";
import AssessmentTier from "./resultItems/AssessmentTier";
import ColorCodedCriteriaAvatars from "../components/resultItems/ColorCodedCriteriaAvatars";
import {
  toggleOptionHidden,
  saveUserSort,
  toggleStar
} from "../actions/userEdits";
import { connect } from "react-redux";
import UserNotesModal from "../containers/UserNotesModal";
import Dialog from "material-ui/Dialog";
import EvaluatedOptionCard from "../components/EvaluatedOptionCard";
import {Draggable} from "react-beautiful-dnd";
import {getSortOrderText} from "../actions/filterOptions";
import Toggle from "material-ui/Toggle";
import {buttonTextStyle} from "../containers/Results";
import AppBar from "material-ui/AppBar";
import SortIcon from "material-ui/svg-icons/content/sort";

class CaveatVisualization extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      showGenRptModal: false,
      generateReports: false,
      userNoteOptionID: null,
      showModal: false
    };
  }

  //builds HTML for result rows (for monitoring and decision rules)
  render() {
    let {
      readOnly,
      responseID,
      section,
      options,
      displayCriteria,
      filterOptions,
      colorCodedCriteria,
      hideAllOptionsLink,
      onToggleOptionHidden,
      response,
      topOptionsOnly
    } = this.props;

    const enabledActions = {
      hide: true,
      star: false,
      sort: true,
      ...(this.props.enabledActions || {})
    }


    const categoryProp =
      section === "assessment"
        ? filterOptions.categoryProp || "Output-Based Category"
        : "Output-Based Category";
    const categoryLabel = section === "assessment"
      ? categoryProp === "Output-Based Category" ? "Assessment Output" : "Assessment Category"
      : section === "monitoring"
        ? "Data Category"
        : "Category"
    let sectionEdits = this.props.userEdits[section] || {};
    let hiddenOptIDs = sectionEdits.hiddenOptIDs || [];
    let starred = sectionEdits.starred || [];
    let notesList = this.props.userEdits.userNotes || {};

    if (topOptionsOnly) {
      options = [...options.filter((o) => starred.indexOf(o.id) !== -1)]
    }

    const maxCaveats = Math.max(
      ...options.map(option => option.caveats.filter(c => c.score < 0).length)
    );

    const instructionText = getSortOrderText(filterOptions.order, section).description;
    const sortTitle = getSortOrderText(filterOptions.order).title;
    let noteOption = options.find((opt) => opt.id === this.state.userNoteOptionID);
    let noteTitle = noteOption ? noteOption.title : "";
    noteTitle = noteTitle === "" || section === "assessment" ? noteTitle : noteTitle + " (Category: " + noteOption.category.title + ")";
    return (
      <div>
        {!hideAllOptionsLink && (
          <CardTitle subtitle={<div>
              <b>Current Sorting Method:</b> <i>{sortTitle}</i> - {instructionText}
            </div>} />
        )}
        <br />

        <div>
          {options.length > 0 ? (
            <div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginBottom: 20,
                  fontWeight: "500",
                  whiteSpace: "nowrap",
                  textAlign: "center"
                }}
              >
                { enabledActions.hide && <div style={ToggleHideOption.style}>&nbsp;</div> }
                { enabledActions.star && <div style={Star.style}>Top Option</div> }
                <div style={Notes.style}>Notes</div>
                {displayCriteria ? (
                  colorCodedCriteria ? (
                    <div style={ColorCodedCriteriaAvatars.style}>Criteria</div>
                  ) : (
                    <div style={PassFailCriteria.style}>Criteria</div>
                  )
                ) : null}
                <div style={CondensedCaveatAvatars.style}>Caveats</div>
                <div style={OptionInlineCategory.style}>
                  {categoryLabel}
                </div>
                {section === "assessment" && <div style={{...AssessmentTier.style, textAlign:"left", maxWidth:50, marginLeft:-25}}>Assessment 'Tier'</div>}
                <div style={{...OptionTitle.style, textAlign:"center"}}>Option</div>
              </div>

              <OptionSorter
                onSortChange={this.onSortChange.bind(this)}
                items={options.map((option, index) => (
                  <Draggable
                    key={"draggable-" + option.id}
                    index={index}
                    option={option}
                    draggableId={option.id}
                    isDragDisabled={readOnly || this.props.inHarvestStrategy ||
                    (filterOptions
                      ? filterOptions.order !== CUSTOMIZED_ORDER
                      : true)}
                  >

                    {(provided, snapshot) => (
                      <div
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        style={{
                          userSelect: "none",
                          background: snapshot.isDragging ? "lightgreen" : "",
                          ...provided.draggableProps.style
                        }}
                      >
                  <CaveatVisualizationRow
                    key={"cv-" + option.id}
                    option={option}
                    note={notesList[option.id]}
                    onToggleOptionHidden={option =>
                      onToggleOptionHidden(option, section, responseID)
                    }
                    hidden={hiddenOptIDs.indexOf(option.id) !== -1}
                    onNoteClick={() => this.setState({userNoteOptionID: option.id})}
                    onClick={this.handleOptionClick}
                    maxCaveats={maxCaveats}
                    displayCriteria={displayCriteria}
                    colorCodedCriteria={colorCodedCriteria}
                    readOnly={readOnly}
                    categoryProp={categoryProp}
                    enabledActions={enabledActions}
                    onStarClick={this.handleStarClick}
                    starred={starred.indexOf(option.id) !== -1}
                    section={section}
                  />
                      </div>
                  )}
                </Draggable>
                ))}
              />
            </div>
          ) : (
            <div style={{ padding: 40 }}>
              { hideAllOptionsLink ? this.props.inHarvestStrategy ? "No top options" : <span>No starred options. <a href="javascript:window.location = window.location.pathname.replace(/\d$/, 3);">Go back</a> to the previous step</span> : `No options match filtering options` }
            </div>
          )}
        </div>
        {!hideAllOptionsLink &&
          <AppBar
            title={<div>
              {!readOnly && (
                <RaisedButton
                  primary={true}
                  style={{marginBottom: -13, boxShadow:''}}
                  label="Narrow Your Results"
                  labelPosition="before"
                  containerElement={
                    <Link
                      to={`/resultsReview/${this.props.responseID}/${
                        this.props.section
                      }/0`}
                    />
                  }
                />
              )}
            </div>}
            style={{
              backgroundColor: "white",
              boxShadow: "none",
              color: "black",
              zIndex: 1
            }}
            titleStyle={{ color: "black", fontSize:"18px" }}
            iconStyleRight={{ color: "black" }}
            iconElementLeft={<div />}
            iconElementRight={
              <div>

                <div
                style={{
                  display: "inline-flex",
                  position: "relative",
                  bottom: -2,
                  alignItems: 'center',
                  ...buttonTextStyle,
                }}
              >
                <Toggle
                  label="Narrowed Options Only"
                  labelPosition="left"
                  style={{
                    display: "inline-block",
                    width: "auto",
                    marginRight: 10,
                    border: "1px solid lightgrey",
                    borderRadius: 6,
                    padding:5,
                    ...buttonTextStyle
                  }}
                  thumbStyle={{
                    backgroundColor: "rgb(0, 188, 212)"
                  }}
                  toggled={this.props.filterOptions.shortList}
                  onClick={this.props.toggleShortList}
                />
                <Toggle
                  label="Show Hidden Options"
                  onClick={this.props.toggleHiddenOptions}
                  labelPosition="left"
                  toggled={this.props.filterOptions.displayHiddenOptions}
                  disabled={this.props.filterOptions.shortList}
                  style={{
                    display: "inline-block",
                    width: "auto",
                    marginRight: 10,
                    border: "1px solid lightgrey",
                    borderRadius: 6,
                    padding:5,
                    ...buttonTextStyle
                  }}
                  thumbStyle={{
                    backgroundColor: "rgb(0, 188, 212)"
                  }}
                />
              </div>

                <RaisedButton
                  label="Sort Options"
                  labelPosition="before"
                  icon={<SortIcon />}
                  onClick={this.props.onOpenFiltersClick.bind(null, this.props.section)}
                />
              </div>
            }
          />
        }
        {
          <UserNotesModal response={response} optionID={this.state.userNoteOptionID} optionTitle={noteTitle} readOnly={readOnly} open={!!this.state.userNoteOptionID} onRequestClose={this.handleRequestUserNotesClose} />
        }
        <Dialog
          modal={false}
          open={this.state.showModal}
          onRequestClose={this.handleRequestOptionModalClose}
          autoScrollBodyContent={true}
          contentStyle={{
            position: "absolute",
            left: "50%",
            top: "50%",
            transform: "translate(-50%, -50%)"
          }}
        >
          {this.state.selectedOption ? (
            <EvaluatedOptionCard
              answerTextLookup={this.props.answerTextLookup}
              questionLookup={this.props.questionLookup}
              {...this.state.selectedOption}
              initiallyExpanded={true}
            />
          ) : null}
        </Dialog>
      </div>
    );
  }

  handleOptionClick = option => {
    this.setState({
      showModal: true,
      selectedOption: option
    });
  };

  handleRequestOptionModalClose = () => {
    this.setState({ showModal: false });
  };

  onSortChange(options) {
    var optionIDList = options.map(o => o.id)

    //*bjs #96
    //if hidden options are not displayed and they exist, then need to add their ids to the end userSortList
    //this maintains the hidden IDs in their sorted order relative to themselves
    if(!this.props.filterOptions.displayHiddenOptions &&
    this.props.userEdits &&
    this.props.userEdits[this.props.section] &&
    this.props.userEdits[this.props.section].hiddenOptIDs){

      var hiddenIDs;
      if(this.props.userEdits[this.props.section].userSortOrder){
        //normal case of having userSortOrder and hiddenOptIDs arrays
        hiddenIDs = this.props.userEdits[this.props.section].userSortOrder.filter((optionID) => this.props.userEdits[this.props.section].hiddenOptIDs.indexOf(optionID) !== -1);
      }else{
        //case of hiding, then toggling to not display hidden, then sorting
        //since no sorting has happened yet, there is no userSortOrder created. Therefore, have to copy the list of hiddenOptIDs.
        //Unfortunately, the order is based on the order that the user hides the options, not their placement in the list, but no way to get that without creating new server values
        hiddenIDs = this.props.userEdits[this.props.section].hiddenOptIDs;
      }

      optionIDList = optionIDList.concat(hiddenIDs)
    }

    this.props.saveUserSort(
      optionIDList,
      this.props.section,
      this.state.filter,
      this.props.responseID
    );
  }

  handleStarClick = (option) => {
    this.props.onToggleStar(option, this.props.section, this.props.responseID);
  }

  handleRequestUserNotesClose = () => {
    this.setState({
      userNoteOptionID: null
    });
  };

}

const mapStateToProps = (state, ownProps) => {
  return {};
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onToggleOptionHidden: (option, section, responseID) => {
      dispatch(toggleOptionHidden(option, section, responseID));
    },
    onToggleStar: (option, section, responseID) => dispatch(toggleStar(option, section, responseID)),
    saveUserSort: (optIDs, section, filter, responseID) => dispatch(saveUserSort(optIDs, section, filter, responseID))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CaveatVisualization);
